export const VIDEO_PREVIEW_MODE = {
    DESKTOP: 'DESKTOP',
    MOBILE: 'MOBILE',
};
